import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c897648c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c897648c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c897648c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c897648c')) {
      api.createRecord('c897648c', component.options)
    } else {
      api.reload('c897648c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c897648c&scoped=true", function () {
      api.rerender('c897648c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/challenge-friends/views/index.vue"
export default component.exports